import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';

import { Typography } from '@mui/material';
import Container from 'components/Container';
import LiterarySidebar from '../Literaryclub2023/components/LiterarySidebar';
import Sidebar2025 from '../Literaryclub2023/components/Sidebar2025';

const AvidReader2025 = () => {
    const theme = useTheme();
    const [currentImage, setCurrentImage] = useState(0);
    const [viewerIsOpen, setViewerIsOpen] = useState(false);

    const openLightbox = (index) => {
        setCurrentImage(index);
        setViewerIsOpen(true);
    };

    const closeLightbox = () => {
        setCurrentImage(0);
        setViewerIsOpen(false);
    };

    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
    });
    const [config, setConfig] = useState({ base_image_url_2025: '' });
    useEffect(() => {
      fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
        .then(response => response.json())
        .then(data => setConfig(data))
        .catch(error => console.error('Error fetching config:', error));
    }, []);
    
    const p1 = `${config.base_image_url_2025}/home/events-activities/association/LitreryClub/AvidReader/1.webp`;
    const p2 = `${config.base_image_url_2025}/home/events-activities/association/LitreryClub/AvidReader/2.webp`;
  
    const photos = [
        {
            src: p1,
            source: p1,
            rows: 1.5,
            cols: 2,
        },
        {
            src: p2,
            source: p2,
            rows: 1.5,
            cols: 2,
        }
    ];

    return (
        <Main>

            <Container>

                <Grid container spacing={4}>
                    <Grid item xs={12} md={8}>
                        <Box>

                            <Box paddingX={{ xs: 0, sm: 4, md: 6 }}>
                                <Typography variant='h5' align='center' >
                                AVID READERS FOR THE MONTHS OF NOVEMBER-DECEMBER: 2025
                                </Typography>
                                {/* <Typography
                                    fontSize="x-small"
                                ><br /><br />
                                    Class: 2  &  Date: 16 October 2025
                                </Typography> */}
                                <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                            ><br />
                                "Books are the quietest and most constant of friends; they are the most accessible and wisest of counsellors, and the most patient of teachers. ― Charles W. Eliot"

                                <br />
                            </Typography>

                                <br />
                                <Typography variant={'subtitle1'} align={'justify'}>
                                The Department of Library at National Public School, Yeshwanthpur, recognises students as Avid Readers, celebrating their passion for reading and fostering their development as skilled conversationalists.  Reading is a fundamental skill that plays a crucial role in personal and academic success thus marking a corner stone for all moral techniques. Keeping this in mind, the assessment criteria for students included their enthusiasm for reading, ability to summarise on what they have read and maintenance of proper library conduct.
                                <br></br>
                                 On Saturday, 22 November 2025 and Thursday, 11 December 2025, the students of Classes 1 to 8 were conferred with an Avid Reader Badge as an acknowledgement for their reading skills. The Vice Principal, Ms. Jeshma Ma’am, congratulated the students for their enthusiasm in reading and encouraged others to develop the habit as well, motivating them to strive for Avid Reader badges in the future.
                                <br></br>
                                
                                </Typography>
                            </Box>
                            <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                            ><br />
                                "The more that you read, the more things you will know."

                                <br />
                            </Typography>

                            <Box>
                                <ImageList
                                    variant="quilted"
                                    cols={2}
                                    rowHeight={isMd ? 300 : 200}
                                    gap={isMd ? 16 : 4}
                                >
                                    {photos.map((item, i) => (
                                        <ImageListItem key={i} cols={item.cols} rows={item.rows}>
                                            <LazyLoadImage
                                                height={'100%'}
                                                width={'100%'}
                                                src={item.src}
                                                alt="..."
                                                effect="blur"
                                                onClick={() => openLightbox(i)}
                                                style={{
                                                    objectFit: 'cover',
                                                    filter:
                                                        theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                                                    cursor: 'poiner',
                                                    borderRadius: 8,
                                                }}
                                            />
                                        </ImageListItem>
                                    ))}
                                </ImageList>
                            </Box>
                            {viewerIsOpen && (
                                <Lightbox
                                    mainSrc={photos[currentImage].src}
                                    nextSrc={photos[(currentImage + 1) % photos.length].src}
                                    prevSrc={
                                        photos[(currentImage + photos.length - 1) % photos.length].src
                                    }
                                    onCloseRequest={() => closeLightbox()}
                                    onMovePrevRequest={() =>
                                        setCurrentImage((currentImage + photos.length - 1) % photos.length)
                                    }
                                    onMoveNextRequest={() =>
                                        setCurrentImage((currentImage + 1) % photos.length)
                                    }
                                    reactModalStyle={{ overlay: { zIndex: 1500 } }}
                                />
                            )}
                        </Box>
                    </Grid>

                    <Grid item xs={12} md={4}>

                        
                        <Box marginBottom={4}>
                            <Sidebar2025/>
                        </Box>
                        {/* <Box marginBottom={4}>
                                    <Archive2023/>
                        </Box> */}
                        <Box marginBottom={4}>
                                    <LiterarySidebar/>
                        </Box>
                    </Grid>
                </Grid>
            </Container>
        </Main>


    );
};

export default AvidReader2025;